document.addEventListener("DOMContentLoaded", function () {

    const btn = document.getElementById("whatsapp-order-button");

    if (!btn) return;

    btn.addEventListener("click", async function () {
        btn.disabled = true;
const originalText = btn.innerHTML;
btn.innerHTML = "⏳ Preparando pedido...";

        const phone = "5218123243696"; // <-- Cambia por tu número

        try {

          const response = await fetch("/cart.js");
const cart = await response.json();
const shopUrl = window.location.origin;

let message = "🛒 *NUEVO PEDIDO*\n\n";

cart.items.forEach(item => {

    const precio = (item.final_price / 100).toFixed(2);
    const subtotal = ((item.final_price * item.quantity) / 100).toFixed(2);

    message +=
`━━━━━━━━━━━━━━
📦 *${item.product_title}*
${item.variant_title && item.variant_title !== "Default Title" ? "🏷️ " + item.variant_title + "\n" : ""}Cantidad: ${item.quantity}
Precio: $${precio}
Subtotal: $${subtotal}
🔗 Producto: ${item.handle}

`;

});

message += "━━━━━━━━━━━━━━\n";
message += `💰 *TOTAL:* $${(cart.total_price / 100).toFixed(2)}\n\n`;

message += "👤 *Nombre:*\n";
message += "📞 *Teléfono:*\n";
message += "💬 *Comentarios:*\n";

window.open(
    "https://wa.me/" + phone + "?text=" + encodeURIComponent(message),
    "_blank"
);
btn.disabled = false;
btn.innerHTML = originalText;
        } catch (e) {

            btn.disabled = false;
btn.innerHTML = originalText;

alert("No fue posible leer el carrito.");

        }

    });

});